import React, { useEffect, useState } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import ItemComboBoxStr, { ComboBoxItemTypeS } from '../../atoms/ComboBox/ItemComboBoxStr';
import MessageDialog, { MessageDialogResponse } from '../../atoms/Dialog/MessageDialog';
import { useModal } from '../../../function/useModal';
import dayjs from 'dayjs';
import ItemCalender from '../../atoms/Calendar/ItemCalender';
import Paper from '@material-ui/core/Paper';
import ReportPageFooter from './ReportPageFooter';
import { GetReportFile, SelectDataType, CreateCombBoxItems } from './Report';
import { NAME_DEV_SET, GetNameDevSetListByEst1 } from '../../../function/NameDevSetModel';
import { TableBaseStyle, ReportJudgeStyle } from "./ReportStyle";
import DateInput from '../../atoms/Calendar/DateInput';

type ReportPageProps = {};

const ReportPage: React.FC<ReportPageProps> = () => {
  const { t } = useTranslation();
  const tableBaseStyle = TableBaseStyle();
  const reportJudgeStyle = ReportJudgeStyle();

  const [selectData, setSelectData] = useState<SelectDataType>({
    devIndex: '0',
    selectDate: dayjs(new Date()).format('YYYY-MM-DD'),
    isVibrationTrend: false,
    isBearing: false,
    isRotateBar: false,
    isElecTrend: false,
    isTemperature: false,
  });
  const [selectComboBoxList, setSelectComboBoxList] = useState<ComboBoxItemTypeS[]>([]);
  const [buttonEnable, setButtonEnable] = useState<boolean>(true);

  const [flgMsgDlg, actMsgDlg] = useModal<MessageDialogResponse>();
  const [dlgmsg, setDlgmsg] = useState<string>('');

  const msgdlg = flgMsgDlg ? <MessageDialog dialog={actMsgDlg} message={dlgmsg} /> : null;

  useEffect(() => {
    let isError: boolean = false;
    setButtonEnable(false);
    let cmdItems: ComboBoxItemTypeS[] = [];
    GetNameDevSetListByEst1()
      .then((r: NAME_DEV_SET[]) => {
        cmdItems = CreateCombBoxItems(r);
        setSelectComboBoxList(cmdItems);
        if (cmdItems.length !== 0) {
          setSelectData((prev) => ({ ...prev, devIndex: cmdItems[0].key }));
        } else {
          setDlgmsg(t('ReportPage.機器情報がありません', '機器情報がありません'));
          actMsgDlg.open();
          isError = true;
        }
      })
      .catch((e) => {
        setDlgmsg(t('ReportPage.データ取得中にエラーが発生しました', 'データ取得中にエラーが発生しました'));
        actMsgDlg.open();
        console.error(['ReportPage - useEffect - Error', e]);
        isError = true;
      })
      .finally(() => {
        if (!isError) setButtonEnable(true);
      });
  }, []);

  /**
   * 機器選択変更Event
   * @param value
   */
  const onDevIndexSelectDataChange = (e: React.ChangeEvent<{ name?: string; value: unknown }>) => {
    const selectDevIndex = String(e.target.value);
    setSelectData((prev) => ({ ...prev, devIndex: selectDevIndex }));
  };
  /**
   * カレンダー値変更
   * @param value
   */
  const changeCalendarValueAction = (value: string) => {
    setSelectData((prev) => ({ ...prev, selectDate: value }));
  };

  /**
   * チェックボックス切替
   * @param event
   */
  const onInputChackBoxChenge = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
    switch (index) {
      case 1:
        setSelectData((prev) => ({ ...prev, isVibrationTrend: !prev.isVibrationTrend }));
        break;
      case 2:
        setSelectData((prev) => ({ ...prev, isBearing: !prev.isBearing }));
        break;
      case 3:
        setSelectData((prev) => ({ ...prev, isRotateBar: !prev.isRotateBar }));
        break;
      case 4:
        setSelectData((prev) => ({ ...prev, isElecTrend: !prev.isElecTrend }));
        break;
      case 5:
        setSelectData((prev) => ({ ...prev, isTemperature: !prev.isTemperature }));
        break;
    }
  };

  /**
   * 選択ボタンアクション
   */
  const selectAction = () => {
    setButtonEnable(false);
    var res = GetReportFile(selectData)
      .then((res) => {
        if (res) {
          console.debug(['selectAction - ok', selectData]);
        } else {
          setDlgmsg(t('ReportPage.ファイル出力中にエラーが発生しました', 'ファイル出力中にエラーが発生しました'));
          actMsgDlg.open();
          console.debug(['selectAction - ng', selectData]);
        }
      })
      .catch((r) => {
        setDlgmsg(t('ReportPage.ファイル出力中にエラーが発生しました', 'ファイル出力中にエラーが発生しました'));
        actMsgDlg.open();
        console.debug(['selectAction - error', selectData]);
      })
      .finally(() => {
        setButtonEnable(true);
      });
  };

  return (
    <>
      <Grid container justify="flex-start" spacing={1} direction="row" alignItems="center" style={{ margin: 2 }}>
        <Grid item xs={12}>
          <Paper elevation={3} classes={{ root: reportJudgeStyle.paperRoot }}>
            <Table aria-label="a main table">
              <TableBody>
                <TableRow>
                  <TableCell className={tableBaseStyle.headerCell} width={100}>
                    {t('ReportPage.機器', '機器')}</TableCell>
                  <TableCell className={tableBaseStyle.bodyCell}>
                    <ItemComboBoxStr
                      itemList={selectComboBoxList}
                      label={''}
                      value={selectData.devIndex}
                      onChangeEvent={onDevIndexSelectDataChange}
                    ></ItemComboBoxStr>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className={tableBaseStyle.headerCell}>{t('ReportPage.計測日', '計測日')}</TableCell>
                  <TableCell className={tableBaseStyle.bodyCell}>
                    <DateInput
                      //labelCssString={classes.labelStyle}
                      initialValue={dayjs(selectData.selectDate).format('YYYY-MM-DD')}
                      label={''}
                      labelPosition={1}
                      onDateChange={changeCalendarValueAction}
                    ></DateInput>
                    {/* <ItemCalender
                      label={''}
                      labelPosition={1}
                      defaultValue={selectData.selectDate}
                      onChange={changeCalendarValueAction}
                    /> */}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className={tableBaseStyle.headerCell}>{t('ReportPage.出力項目', '出力項目')}</TableCell>
                  <TableCell className={tableBaseStyle.bodyCell}>
                    <label className={tableBaseStyle.checkBoxLabel}>
                      <input
                        type="checkbox"
                        onChange={(e) => onInputChackBoxChenge(e, 1)}
                        checked={selectData.isVibrationTrend}
                        value="js"
                      />
                      {t('ReportPage.振動トレンド', '振動トレンド')}
                    </label>
                    <label className={tableBaseStyle.checkBoxLabel}>
                      <input
                        type="checkbox"
                        onChange={(e) => onInputChackBoxChenge(e, 2)}
                        checked={selectData.isBearing}
                        value="js"
                      />
                      {t('ReportPage.軸受', '軸受')}
                    </label>
                    <label className={tableBaseStyle.checkBoxLabel}>
                      <input
                        type="checkbox"
                        onChange={(e) => onInputChackBoxChenge(e, 3)}
                        checked={selectData.isRotateBar}
                        value="js"
                      />
                      {t('ReportPage.回転子バー損傷', '回転子バー損傷')}
                    </label>
                    <label className={tableBaseStyle.checkBoxLabel}>
                      <input
                        type="checkbox"
                        onChange={(e) => onInputChackBoxChenge(e, 4)}
                        checked={selectData.isElecTrend}
                        value="js"
                      />
                      {t('ReportPage.電流トレンド', '電流トレンド')}
                    </label>
                    <label className={tableBaseStyle.checkBoxLabel}>
                      <input
                        type="checkbox"
                        onChange={(e) => onInputChackBoxChenge(e, 5)}
                        checked={selectData.isTemperature}
                        value="js"
                      />
                      {t('ReportPage.温度', '温度')}
                    </label>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Paper>
        </Grid>
        <Grid item xs={12}>
          <ReportPageFooter onClickSelectButton={selectAction} buttonEnable={buttonEnable}></ReportPageFooter>
        </Grid>
      </Grid>
      {msgdlg}
    </>
  );
};

export default ReportPage;
